import lastIndex from './lastIndex'

export default function last<T>(items: T[]): T {
  return items[lastIndex(items)]
}
